import styled, { css } from "styled-components"
import { getColorFromVariant } from "../utils"

const fontSize = (size) => {
  switch (size) {
    case "smallv2":
      return "16px"
    case "small":
      return "0.75rem"
    case "medium":
      return "1.25rem"
    case "large":
      return "1.5rem"
    case "extralarge":
      return "1.75rem"
    default:
      return "1rem"
  }
}

export const StyledP = styled.p`
  color: ${({ variant }) => getColorFromVariant(variant)};
  font-size: ${({ size }) => fontSize(size)};
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  font-weight: ${({ theme }) => theme.fonts.body.weight};
  line-height: 1.4;

  ${({ marginless }) =>
    marginless &&
    css`
      margin: 0;
    `}

  ${({ bold }) =>
    bold &&
    css`
      font-weight: bold;
    `}

  ${({ inline }) =>
    inline &&
    css`
      display: inline;
    `}

  ${({ wrap }) =>
    wrap &&
    css`
      word-wrap: break-word;
      word-break: break-word;
    `}

  ${({ nowrap }) =>
    nowrap &&
    css`
      overflow: hidden;
      white-space: nowrap;
    `}

  ${({ profileLabel }) =>
    profileLabel &&
    css`
      color: #555555;
      font-weight: 600;
      font-size: 16px;
    `}

  ${({ profileData }) =>
    profileData &&
    css`
      color: #333333;
      font-weight: 400;
      font-size: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
    `}

    &:empty {
    display: none;
  }

  ${({ multiline }) =>
    multiline &&
    css`
      white-space: pre-line;
    `}

  ${({ overflow }) =>
    overflow &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
    `}

  text-align: ${({ align }) => align};
`
